export default "__VITE_ASSET__CNNcnFZC__"